<div class="space40"></div>

<form [formGroup]="specBox3FormGroup">
    <div formGroupName="specificatieBox3">
        <div formGroupName="opbouw">
            <div class="row">
                <div class="col col-1">
                    <b>Fictief rendement</b>
                </div>
                <div class="col-2">
                    <snelstart-ui-button
                            (click)="this.showDialog()"
                            class="custom-input-150"
                            icon="plus"
                            type="secondary">
                        Specificatie
                    </snelstart-ui-button>
                </div>
                <div class="col-3">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            align="right"
                            class="custom-input-150"
                            formControlName="inkomenBox3"
                            id="inkomenBox3"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="col-4"></div>
            </div>
        </div>
    </div>
</form>


@if (aangifte.box3?.berekenWerkelijkRendement) {
    <form [formGroup]="specOWRFormGroup">
        <div formGroupName="specificatieOwr">
            <div formGroupName="opbouw">
                <div class="row">
                    <div class="col col-1">
                        <b>Werkelijk rendement</b>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-button
                                (click)="this.showDialogOWR()"
                                class="custom-input-150"
                                icon="plus"
                                type="secondary">
                            Specificatie
                        </snelstart-ui-button>
                    </div>
                    <div class="col-3">
                        <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'werkelijkRendement'])?.value >= 0">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="werkelijkRendement"
                                    id="inkomenBox3"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'werkelijkRendement'])?.value < 0">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="negatiefRendement"
                                    id="inkomenBox3"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                    </div>
                    <div class="col-4"></div>
                </div>
            </div>
        </div>
    </form>

} @else {
    <div *ngIf="this.aangifte.aangifteJaar >= 2025">
        <p>Er zijn geen gegevens voor het berekenen van het werkelijk rendement (OWR) ingevuld.</p>
    </div>
}

<!--<div *ngIf="this.aangifte.box3?.berekenWerkelijkRendement">-->
<!--    Voor de box 3-belasting wordt uitgegaan van het laagste voordeel: €-->
<!--    <b>{{ this.laagsteRendement | number:'1.0-0':'nl-NL' }}</b>.-->
<!--    <div class="space40"></div>-->
<!--</div>-->

<snelstart-ui-dialog-definition [(visible)]="dialogVisible"
                                [title]="'Berekend fictief rendement ' + this.incomeTaxEntity.year" id="owr"
                                size="lg">
    <snelstart-ui-dialog-body>
        <form [formGroup]="specBox3FormGroup">

            <div formGroupName="specificatieBox3">
                <div formGroupName="opbouw">
                    <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementBanktegoedenNederland'])?.value > 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement bankrekeningen Nederland</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementBanktegoedenNederland"
                                        id="rendementBanktegoedenNederland"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>
                    <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementBanktegoedenBuitenland'])?.value > 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement bankrekeningen buitenland</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementBanktegoedenBuitenland"
                                        id="rendementBanktegoedenBuitenland"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>
                    <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementBeleggingen'])?.value > 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement beleggingen</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementBeleggingen"
                                        id="rendementBeleggingen"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>
                    <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementOnroerendeZakenNederland'])?.value > 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement onroerende zaken Nederland</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementOnroerendeZakenNederland"
                                        id="rendementOnroerendeZakenNederland"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>
                    <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementOnroerendeZakenBuitenland'])?.value > 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement onroerende zaken buitenland</p>
                            </div>
                            <div class="col-3">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementOnroerendeZakenBuitenland"
                                        id="rendementOnroerendeZakenBuitenland"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>
                    <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementVorderingen'])?.value > 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement vorderingen</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementVorderingen"
                                        id="rendementVorderingen"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>
                    <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementContantGeld'])?.value > 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement contant geld</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementContantGeld"
                                        id="rendementContantGeld"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>
                    <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementCrypto'])?.value > 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement cryptobezittingen</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementCrypto"
                                        id="rendementCrypto"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>
                    <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementKapitaalverzekeringen'])?.value > 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement kapitaalverzekeringen</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementKapitaalverzekeringen"
                                        id="rendementKapitaalverzekeringen"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>
                    <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementPeriodiekeUitkeringen'])?.value > 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement periodieke uitkeringen</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementPeriodiekeUitkeringen"
                                        id="rendementPeriodiekeUitkeringen"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>
                    <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementOverigeBezittingen'])?.value > 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement overige bezittingen</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementOverigeBezittingen"
                                        id="rendementOverigeBezittingen"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>
                    <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementNettoPensioen'])?.value > 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement netto pensioen</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementNettoPensioen"
                                        id="rendementNettoPensioen"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>
                    <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementAftrekbareSchulden'])?.value > 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement aftrekbare schulden</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementAftrekbareSchulden"
                                        id="rendementAftrekbareSchulden"
                                        prefix="€ -"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col col-1">
                            <b>Totaal fictief rendement</b>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [useBoldValue]="true"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="inkomenBox3"
                                    id="inkomenBox3"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
            </div>
        </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
        <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren
        </snelstart-ui-button>
        <snelstart-ui-button btn-x icon="check" id="save" type="primary">Akkoord
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>


<snelstart-ui-dialog-definition [(visible)]="dialogOWRVisible"
                                [title]="'Berekend werkelijk rendement ' + this.incomeTaxEntity.year" id="owr"
                                size="lg">
    <snelstart-ui-dialog-body>
        <form [formGroup]="specOWRFormGroup" class="pt-1">
            <div formGroupName="specificatieOwr">
                <div formGroupName="opbouw">

                    <!--                    rendementBankrekeningenNederland-->
                    <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'rendementBankrekeningenNederland'])?.value != 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement bankrekeningen Nederland</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementBankrekeningenNederland"
                                        id="rendementBankrekeningenNederland"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>

                    <!--                    rendementBankrekeningenBuitenland-->
                    <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'rendementBankrekeningenBuitenland'])?.value != 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement bankrekeningen buitenland</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementBankrekeningenBuitenland"
                                        id="rendementBankrekeningenBuitenland"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>

                    <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'rendementBankrekeningenGroen'])?.value != 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement groene bankrekeningen</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementBankrekeningenGroen"
                                        id="rendementBankrekeningenGroen"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>

                    <!--                    rendementEffecten-->
                    <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'rendementEffecten'])?.value != 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement beleggingen</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementEffecten"
                                        id="rendementEffecten"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>

                    <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'rendementEffectenGroen'])?.value != 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement groene beleggingen</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementEffectenGroen"
                                        id="rendementEffecten"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>

                    <!--                    rendementOnroerendeZakenNl-->
                    <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'rendementOnroerendeZakenNl'])?.value != 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement onroerende zaken Nederland</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementOnroerendeZakenNl"
                                        id="rendementOnroerendeZakenNl"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>

                    <!--                    rendementOnroerendeZakenBtl-->
                    <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'rendementOnroerendeZakenBtl'])?.value != 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement onroerende zaken buitenland</p>
                            </div>
                            <div class="col-3">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementOnroerendeZakenBtl"
                                        id="rendementOnroerendeZakenBtl"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>

                    <!--                    rendementVorderingen-->
                    <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'rendementVorderingen'])?.value != 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement vorderingen</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementVorderingen"
                                        id="rendementVorderingen"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>

                    <!--                    rendementContantGeld-->
                    <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'rendementContantGeld'])?.value != 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement contant geld</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementContantGeld"
                                        id="rendementContantGeld"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>


                    <!-- rendementCrypto-->
                    <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'rendementCrypto'])?.value != 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement cryptobezittingen</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementCrypto"
                                        id="rendementCrypto"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>

                    <!-- rendementKapitaalverzekeringen-->
                    <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'rendementKapitaalverzekeringen'])?.value != 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement kapitaalverzekeringen</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementKapitaalverzekeringen"
                                        id="rendementKapitaalverzekeringen"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>

                    <!--                    rendementPeriodiekeUitkeringen-->
                    <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'rendementPeriodiekeUitkeringen'])?.value != 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement periodieke uitkeringen</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementPeriodiekeUitkeringen"
                                        id="rendementPeriodiekeUitkeringen"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>

                    <!--                    rendementBouwdepot-->
                    <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'rendementBouwdepot'])?.value != 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement bouwdepot</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementBouwdepot"
                                        id="rendementBouwdepot"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>

                    <!--                    rendementPremiedepot-->
                    <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'rendementPremieDepot'])?.value != 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement premiedepot</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementPremieDepot"
                                        id="rendementPremiedepot"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>

                    <!--                    rendementOverigeBezittingen-->
                    <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'rendementOverigeBezittingen'])?.value != 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement overige bezittingen</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementOverigeBezittingen"
                                        id="rendementOverigeBezittingen"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>

                    <!--                    rendementNettoPensioen-->
                    <!--                    <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'rendementNettoPensioen'])?.value != 0">-->
                    <!--                        <div class="row">-->
                    <!--                            <div class="col col-1">-->
                    <!--                                <p>Rendement netto pensioen</p>-->
                    <!--                            </div>-->
                    <!--                            <div class="col-2">-->
                    <!--                                <snelstart-ui-number-form-control-->
                    <!--                                        [decimals]="0"-->
                    <!--                                        align="right"-->
                    <!--                                        class="custom-input-150"-->
                    <!--                                        formControlName="rendementNettoPensioen"-->
                    <!--                                        id="rendementNettoPensioen"-->
                    <!--                                        prefix="€"-->
                    <!--                                ></snelstart-ui-number-form-control>-->
                    <!--                            </div>-->
                    <!--                            <div class="col-3"></div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->

                    <!--                    rendementSchuldenOgNederland-->
                    <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'rendementSchuldenOgNederland'])?.value != 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement aftrekbare schulden onroerende zaken Nederland</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementSchuldenOgNederland"
                                        id="rendementSchuldenOgNederland"
                                        prefix="€ -"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>

                    <!--                    rendementSchuldenOgBuitenland-->
                    <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'rendementSchuldenOgBuitenland'])?.value != 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement aftrekbare schulden onroerende zaken buitenland
                                </p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementSchuldenOgBuitenland"
                                        id="rendementSchuldenOgOverig"
                                        prefix="€ -"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>

                    <!--                    rendementSchuldenOgOverig-->
                    <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'rendementSchuldenOgOverig'])?.value != 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Rendement aftrekbare schulden overig</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="rendementSchuldenOgOverig"
                                        id="rendementSchuldenOgOverig"
                                        prefix="€ -"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                        </div>
                    </div>

                    <div class="row pt-2">
                        <div class="col col-1">
                            <b>Totaal werkelijk rendement</b>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [useBoldValue]="true"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="werkelijkRendement"
                                    id="werkelijkRendement"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
            </div>

            <div *ngIf="specOWRFormGroup.get(['specificatieOwr', 'opbouw', 'werkelijkRendement'])?.value< 0" class="pt-2">
                <snelstart-ui-alert type="info">
                    Een negatief werkelijk rendement wordt in de berekening gezet op <b>€ 0 werkelijk rendement</b>.
                </snelstart-ui-alert>
            </div>

        </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
        <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren
        </snelstart-ui-button>
        <snelstart-ui-button btn-x icon="check" id="save" type="primary">Akkoord
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

